import React from 'react';
import { useHasEvents } from '../hooks/useHasEvents';
import WhatsNew from './WhatsNew';

const WhatsNewGate: React.FC = () => {
  const { hasEvents } = useHasEvents();

  // Only show What's New when there are NO events
  return !hasEvents ? <WhatsNew /> : null;
};

export default WhatsNewGate;
